import * as React from "react";
import { TileSizes } from "./types";
import { sizeFactory } from "../../providers/size";

interface TilePropsContext {
  hasSubText: boolean;
}

const defaultTileInputContext: TilePropsContext = {
  hasSubText: false,
};

export const TilePropsContext = React.createContext<TilePropsContext>(
  defaultTileInputContext,
);

export const useTileProps = () => React.useContext(TilePropsContext);

export const { useSize: useTileSize, SizeProvider: TileSizeProvider } =
  sizeFactory<TileSizes>({
    defaultSizeContext: { size: "medium" },
  });
